import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SideMenuService {

  public showed: boolean = false;

  constructor() { }
}
